// extracted by mini-css-extract-plugin
export default {"zoomControls":"oaa-z","zoomControlButton":"paa-z","zoomBanner":"qaa-z","bannerButton":"raa-z","imageButton":"saa-z","zoom":"taa-z","zoomContent":"uaa-z"};